(function() {
  define('templates/helpers/stringContains',["handlebars", "underscore"], function(Handlebars, _) {
    return Handlebars.registerHelper("stringContains", function(inputString, searchString, options) {
      if (inputString.indexOf(searchString) !== -1) {
        return options.fn(this);
      } else {
        return options.inverse(this);
      }
    });
  });

}).call(this);

//# sourceMappingURL=stringContains.js.map
;
